<div *ngIf="data; else loading" class="row">
  <div *ngFor="let partnerAgreement of data" class="col-12">
    <div class="card mb-2">
      <div class="card border h-100">
        <div class="card-body">
          <div class="card-title row">
            <div class="col">
              <h5 class="customer-name">
                {{ 'PARTNER_AGREEMENT' | translate }} 
                - {{ partnerAgreement.customerName }} 
                - {{ partnerAgreement.partnerName }}
              </h5>
            </div>
            <div class="col-auto">
              <lib-action-btn [item]="partnerAgreement" [config]="actionConfig"></lib-action-btn>
            </div>
          </div>
        </div>
      </div>
    </div>    
  </div>
</div>

<ng-template #loading>
  <div class="d-flex justify-content-center w-100 pt-4 pb-5">
    <i class="fa fa-spinner fa-spin fa-5x"></i>
  </div>
</ng-template>